package org.hs_soft.runmynesto.domain.model.home.closing_reports.closing_report_detail_model


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CashAssist(
    @SerialName("getClosing")
    val getClosing: GetClosing?=null,
    @SerialName("invalidateClosing")
    val invalidateClosing: GetClosing?=null,
    @SerialName("__typename")
    val typename: String?
)